import React from "react";
import styled from "react-emotion";
import SVG from "react-inlinesvg";
import theme from "components/theme";

import useApiSwr from "../../hooks/useApiSwr";

import trustpilot from "../../shapes/trustpilot-white.svg";

function TrustPilotWidgetFooter(props) {
  const { data: trustpilotReviewsRes } = useApiSwr("trustpilotReviews");

  const businessUnit = trustpilotReviewsRes?.businessUnit;

  if (!businessUnit) return null;

  const {
    trustScore,
    numberOfReviews: { total },
  } = businessUnit;

  return (
    <div className={props.className}>
      <a href="https://de.trustpilot.com/review/kitchenadvisor.de" target="_blank" rel="noopener noreferrer">
        <div>
          <SVG src={trustpilot} uniquifyIDs uniqueHash={"tpwf"} />
        </div>
        <div className={"information"}>
          TrustScore <span className={"bold"}>{trustScore}</span>
        </div>
        <div className={"information"}>
          {total} <span className={"bold"}>Bewertungen</span>
        </div>
      </a>
    </div>
  );
}

TrustPilotWidgetFooter = styled(TrustPilotWidgetFooter)`
  width: 160px;
  margin: 15px auto 15px 0px;
  ${theme.media.xsMax} {
    svg {
      width: auto;
      max-height: 104px;
    }
    margin: auto;
  }
  svg {
    rect[fill="#F2F2F2"],
    #Group-4___tpwf {
      fill: ${theme.colors.grayDark};
    }
    polyline[fill="#20B4B2"] {
      fill: ${theme.colors.grayF};
    }
  }
  .information {
    ${theme.fonts.normal};
    ${theme.fonts.s};
    color: ${theme.colors.grayDark};
  }
  .bold {
    ${theme.fonts.bold};
  }
`;

export default TrustPilotWidgetFooter;
